let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gl0SS")).then(() => parcelRequire('1UJgx'));